import { AuthenticatedLayout } from "../../../layouts";
import { EmployeeReportSetup } from "../../../components/Reports/Employee/EmployeeSetupReport";
import { FC } from "react";

export interface IEmployeeReportSetupPage {}

export const EmployeeReportSetupPage: FC<IEmployeeReportSetupPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="Employee Report"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<EmployeeReportSetup />}
		/>
	);
};
